// 引入axios组件
import axios from 'axios';
import qs from 'qs'; // 处理数据  qs.stringify(params)
import { checkRule } from '@/assets/js/public';
// 引入公共js文件
export default {
  data() {
    return {
      // iconweb:'',
      // logoweb:'',
      // webname:'',
    };
  },
  created() {
    this.$Spin.show();
    setTimeout(() => {
      this.$Spin.hide();
    }, 500);
  },
  computed: {
    websiteinfo() {
      return this.$store.state.websiteinfo;
    },
  },
  methods: {
    // 图片上传回调钩子方法
    handleSuccess(response) {
      checkRule(response, this); // 检查是否有权限
      if (response.code == 1) {
        this.websiteinfo.icon = response.imgpath;
        this.$Message.success('图片上传成功');
      } else {
        this.$Message.error('图片上传失败');
      }
    },
    // 图片上传回调钩子方法
    logoSuccess(weblogo) {
      checkRule(weblogo, this); // 检查是否有权限
      if (weblogo.code == 1) {
        this.websiteinfo.logo = weblogo.imgpath;
        this.$Message.success('图片上传成功');
      } else {
        this.$Message.error('图片上传失败');
      }
    },
    // 图片上传回调钩子方法
    logosjldSuccess(weblogo) {
      checkRule(weblogo, this); // 检查是否有权限
      if (weblogo.code == 1) {
        this.websiteinfo.logosjld = weblogo.imgpath;
        this.$Message.success('图片上传成功');
      } else {
        this.$Message.error('图片上传失败');
      }
    },
    // vue的ajax
    webSitePutData() {
      const self = this;
      axios({
        method: 'post',
        url: '/admin/Website/updateWebSite',
        data: qs.stringify({
          icon: this.websiteinfo.icon,
          logo: this.websiteinfo.logo,
          webname: this.websiteinfo.webname,
          logosjld: this.websiteinfo.logosjld,
        }),
      })
        .then((response) => {
          checkRule(response, self); // 检查是否有权限
          if (response.data.code == 1) {
            self.$Message.success(response.data.msg);
          } else {
            self.$Message.error(response.data.msg);
          }
        })
        .catch((response) => {});
    },
  },
};
